export enum ActivityLogEntityType {
  MENU = 'Menu',
  EMPLOYEE = 'Employee',
  ROLE = 'Role & Permissions',
  SALESTAX = 'Sales Tax',
  COMPS = 'Comps',
  SERVICECHARGE = 'Service Charge',
  TENDER = 'Tender',
  CASHDRAWER = 'Cash Drawer',
}

export enum ActivityLogModules {
  PAYMENTS = 'Payments',
  ROLE = 'Role & Permissions',
  EMPLOYEE = 'Employee',
}

export enum ActivityLogAction {
  ALL = 'all',
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}

export interface EmployeeActivityLogMessage {
  restaurantId?: number;
  businessId: number;
  module: string;
  entityType: ActivityLogEntityType;
  entityName: string;
  entityId?: string; // ID of the entity being tracked (e.g., menu item ID, employee ID)
  action: ActivityLogAction;
  source: string;
  ipAddress?: string;
  userAgent?: string;
  meta?: Record<string, any>;
  data: {
    currentData?: Record<string, any>;
    oldData?: Record<string, any>;
  };
  createdBy: string;
  editorName?: string; // Resolved by producer before enqueueing
}

export enum ActivityLogGetMethodParams {
  ID = 'id',
  RESTAURANTID = 'restaurantId',
  BUSINESSID = 'businessId',
}

export enum ActivityLogGetMethod {
  GETROLEBYID = 'getRoleById',
  GETBYID = 'getById',
  FINDONE = 'findOne',
  GETEMPLOYEEWITHUSERPERMISSIONDATA = 'getEmployeeWithUserPermissionData',
  GETDISCOUNTDATABYID = 'getDiscountDataById',
}

export enum ActivityLogEntityNamePath {
  ROLE = 'role.0.roleName',
  NAME = 'name',
  DISCOUNTNAME = 'discount.name',
  TENDERNAME = 'tenderName',
  RESPONSEDATAUSERNAME = 'response.data.username',
  RESPONSEDATAEMPLOYEEFIRSTNAME = 'response.data.employee.firstName',
  RESPONSEDATAFULLNAME = 'response.data.fullname',
  RESPONSEDATA = 'response.data',
}

export enum ActivityLogIdParam {
  ROLE = 'roles.id',
  ROLEID = 'roleId',
  TENDERID = 'tenderId',
  SALESTAXID = 'salesTax.id',
  SERVICECHARGEID = 'serviceCharge.id',
  CREATEEMPLOYEEDATAID = 'createEmployeeData.id',
  EMPLOYEEID = 'employeeId',
}

export enum ActivityLogAdmin {
  AIOAdmin = 'AIO Admin',
}

export class ActivityLog {
  PK!: string;
  SK!: string;
  id!: string;
  businessId!: number;
  restaurantId?: number | null;
  module!: string;
  entityType!: string;
  entityName!: string;
  entityId?: string;
  action!: string;
  source!: string;
  ipAddress?: string;
  userAgent?: string;
  meta?: Record<string, unknown>;
  data?: Record<string, unknown>;
  createdAt!: string;
  createdBy!: string;
  updatedAt?: string;
  updatedBy?: string;
  editorName!: string;
  moduleEntity!: string;
}
